import React from "react";
import { Modal } from "react-bootstrap";

function DocumentHeading({ blogHeading }) {
  return (
    <h5 className="document-title" id="example-custom-modal-styling-title">
      {blogHeading}
    </h5>
  );
}

export default DocumentHeading;
